import { FaFacebookF, FaLinkedinIn } from "react-icons/fa";
import { FiGithub } from "react-icons/fi";
import { BsInstagram } from "react-icons/bs";

const socialLinks = [
  { href: "https://github.com/aziz-tamim", Icon: FiGithub, label: "GitHub" },
  { href: "https://www.linkedin.com/in/abdul-aziz-tamim-611b2b306/", Icon: FaLinkedinIn, label: "LinkedIn" },
  { href: "https://www.facebook.com/tamim.aziz.38693", Icon: FaFacebookF, label: "Facebook" },
  { href: "https://www.instagram.com/tamimaziz2007/", Icon: BsInstagram, label: "Instagram" },
];

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__inner">
          <a href="/" className="footer__brand" aria-label="Home">
            TAMIM<span>.</span>
          </a>

          <p className="footer__copy">
            &copy; {year} Abdul Aziz. Built with React &amp; passion.{" "}
            <a
              href="https://github.com/aziz-tamim"
              target="_blank"
              rel="noreferrer"
            >
              View Source
            </a>
          </p>

          <ul className="footer__links">
            {socialLinks.map(({ href, Icon, label }) => (
              <li key={label} className="footer__link">
                <a
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={label}
                >
                  <Icon />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
